import styled, { css } from 'styled-components';
import theme from '../../theme';

export const Div = styled.div`
  z-index: 10004;
  min-width: 550px;
  max-width: min(90vw, 720px);
  position: relative;
  border-radius: 0 0 5px 5px;
  padding: 22px 25px;
  background-color: ${({ type }) => theme.colors.button[type].light.background};
  color: ${({ type }) => theme.colors.button[type].light.text};
  transition: transform 0.2s ease-in-out;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  pointer-events: auto;

  ${({ isVisible }) =>
    isVisible
      ? css`
          opacity: 1;
        `
      : css`
          opacity: 0;
        `}
`;

export const Content = styled.div``;

export const Close = styled.button`
  position: relative;
  float: right;
  background: transparent;
  top: -25px;
  right: -16px;
  font-size: 22px;
  color: #464e5f;
`;
